module.exports = __webpack_public_path__ + "img/game2.f843543b.png";